module.exports = __webpack_public_path__ + "img/aminals.05f050c7.jpeg";